import { EditorialFrame } from '../EditorialFrame';
import { IAddressDataProps } from './addressUserData.models';
import * as E from '../../editorialCard.style';

export const AddressUserData = ({
  title,
  name,
  surname,
  street,
  streetNumber,
  postalCode,
  province,
  noteLabel,
  note,
  city,
  ...rest
}: IAddressDataProps) => (
  <EditorialFrame title={title} {...rest}>
    <E.Section>
      <E.P>
        {name} {surname}
        <br />
        <E.Street>
          {street} {streetNumber}
        </E.Street>
        <br />
        {city}
        <br />
        {postalCode} - {province}
      </E.P>
      {note && (
        <E.P>
          {noteLabel} {note}
        </E.P>
      )}
    </E.Section>
  </EditorialFrame>
);
